import { render, staticRenderFns } from "./ArtistRevenueData.vue?vue&type=template&id=2f005ed6&scoped=true"
import script from "./ArtistRevenueData.vue?vue&type=script&lang=js"
export * from "./ArtistRevenueData.vue?vue&type=script&lang=js"
import style0 from "./ArtistRevenueData.vue?vue&type=style&index=0&id=2f005ed6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f005ed6",
  null
  
)

export default component.exports